/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IWebgroupSearchControlsData } from './webgroup-search-controls.data';
import { IWebgroupSearchControlsProps } from './webgroup-search-controls.props.autogenerated';
import { GetCategoryIdFromUrl } from '../../utilities';

export interface IWebgroupSearchControlsViewProps extends IWebgroupSearchControlsProps<IWebgroupSearchControlsData> {
    webgroupFilters?: React.ReactNode;
    webgroupCategories?: React.ReactNode;
    categoryId?: string;
}

/**
 *
 * WebgroupSearchControls component
 * @extends {React.PureComponent<IWebgroupSearchControlsProps<IWebgroupSearchControlsData>>}
 */
class WebgroupSearchControls extends React.PureComponent<IWebgroupSearchControlsProps<IWebgroupSearchControlsData>> {
    public render(): JSX.Element | null {
        const {
            context: { actionContext }
        } = this.props;
        const webgroupFilters =
            this.props.slots.webgroupFilters && this.props.slots.webgroupFilters.length > 0 && this.props.slots.webgroupFilters[0];
        const webgroupCategories =
            this.props.slots.webgroupCategories && this.props.slots.webgroupCategories.length > 0 && this.props.slots.webgroupCategories[0];
        const viewProps = {
            ...this.props,
            categoryId: GetCategoryIdFromUrl(actionContext),
            webgroupFilters,
            webgroupCategories
        };
        return this.props.renderView(viewProps);
    }
}

export default WebgroupSearchControls;
